import { render, staticRenderFns } from "./clientMain.vue?vue&type=template&id=ce72194a&scoped=true&"
import script from "./clientMain.vue?vue&type=script&lang=js&"
export * from "./clientMain.vue?vue&type=script&lang=js&"
import style0 from "./clientMain.vue?vue&type=style&index=0&id=ce72194a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce72194a",
  null
  
)

export default component.exports